<template>
  <div class="page-venue-search">
  <div class="mx-auto flex max-w-4xl flex-col gap-8 px-4 py-12 lg:px-8">
      <div class="flex items-center justify-between">
        <a class="text-sm font-semibold text-brand" href="/vendors">← Back to vendors</a>
        <p class="text-sm text-muted">Venue search with rooms detail</p>
      </div>
    
      <form class="space-y-4 rounded-3xl bg-white p-6 shadow-card ring-1 ring-gray-100">
        <div class="grid gap-4 md:grid-cols-2">
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Location</span>
            <input type="text" class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="City or neighborhood" />
          </label>
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Style</span>
            <select class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink focus:border-brand focus:outline-none">
              <option>Any</option>
              <option>Indoor</option>
              <option>Outdoor</option>
              <option>Estate</option>
              <option>Ballroom</option>
              <option>Loft</option>
            </select>
          </label>
        </div>
        <div class="grid gap-4 md:grid-cols-2">
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Guest capacity</span>
            <input type="text" class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="e.g., 120 - 250" />
          </label>
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Number of Rooms</span>
            <input type="number" min="0" class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="e.g., 40" />
          </label>
        </div>
        <div class="grid gap-4 md:grid-cols-2">
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Budget</span>
            <input type="text" class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="e.g., $5k - $12k" />
          </label>
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Amenities</span>
            <input type="search" class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="Parking, in-house catering, etc." />
          </label>
        </div>
        <button type="button" class="w-full rounded-2xl bg-brand px-4 py-3 text-sm font-semibold text-white shadow-card transition hover:bg-brandDark">Search venues</button>
      </form>
    </div>
  </div>
</template>

<script>
import { useSeoMeta } from '@/utils/seo'

export default {
  name: 'VenueSearchView',
  setup () {
    useSeoMeta({
      title: 'Search Event Venues',
      description: 'Search event venues by location, capacity, style, rooms, budget, and amenities to find the right space for your event.',
      path: '/venue-search'
    })
  }
}
</script>
